import { render } from "./AgendamentosView.vue?vue&type=template&id=23cc3232"
import script from "./AgendamentosView.vue?vue&type=script&lang=js"
export * from "./AgendamentosView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__